export const AppName = {
  WDT: 'wdt',
  GSS: 'gss',
  KWT: 'keyboarding',
  HWT_STUDENT: 'hwt-student',
  MAT_MAN_STUDENT: 'mat-man-student',
  PRM_STUDENT: 'prm-student'
};
